import { ReactComponent as BookMark } from "shared/assets/images/pricing-bookmark.svg";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

interface DarkGradientPricingProps {
  current?: boolean;
  recommended?: boolean;
  description?: string;
  subtitle?: string;
  title?: string;
  price?: ReactNode;
  recommendation?: ReactNode;
  actions?: ReactNode;
  trial?: boolean;
}

const DarkGradientPricing: React.FC<DarkGradientPricingProps> = (props) => {
  const {
    current,
    recommended,
    description,
    subtitle,
    title,
    price,
    recommendation,
    actions,
    trial,
  } = props;

  const { t } = useTranslation();

  return (
    <div id="dark-gradient-pricing">
      {current && (
        <span className="current">
          <BookMark />
          {trial
            ? t("pages.Pricing.cards.currentPlanTrial")
            : t("pages.Pricing.cards.currentPlan")}
        </span>
      )}
      {recommended && (
        <span className="best-for-you">
          {t("pages.Pricing.cards.bestForYou")}
        </span>
      )}
      <span
        className={`price-card-border${
          recommended ? " price-card-border--premium" : ""
        }`}
      >
        <div className="card-content">
          {recommendation}
          {title && <span className="title">{title}</span>}

          {price}
          {subtitle && <span className="subtitle">{subtitle}</span>}
          <span className="description">{description}</span>
        </div>

        {actions}
      </span>
    </div>
  );
};

export default DarkGradientPricing;
